import { render, staticRenderFns } from "./create-appointment.vue?vue&type=template&id=3de74e08&scoped=true"
import script from "./create-appointment.vue?vue&type=script&lang=js"
export * from "./create-appointment.vue?vue&type=script&lang=js"
import style0 from "./create-appointment.vue?vue&type=style&index=0&id=3de74e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de74e08",
  null
  
)

export default component.exports